import { AutogenLayoutCarrierPlanQuickInfo } from "@mcleod/crm/src/autogen/AutogenLayoutCarrierPlanQuickInfo";
import { Navigation } from "@mcleod/core";

export class CarrierPlanQuickInfo extends AutogenLayoutCarrierPlanQuickInfo {
    
    buttonLinkOnClick(_) {
        Navigation.navigateTo(`lme/crm/CarrierPlan?mode=update&key=${this.activeRow?.getString('id', null)}`, { newTab: true });
    }
}